/** The few members of `window` / `document` used to learn that the page is going away. */
export interface PageLifecycleTarget {
  addEventListener(type: string, listener: () => void): void;
  removeEventListener(type: string, listener: () => void): void;
}

export interface PageLifecycleDocument extends PageLifecycleTarget {
  readonly visibilityState: string;
}

/**
 * Calls `flush` when the page is hidden or being closed (`pagehide`, `visibilitychange` to
 * `hidden`). Returns the unsubscribe. This is the `onPageHide` hook of `createSyncingProgressRepo`.
 */
export function browserPageLifecycle(
  win: PageLifecycleTarget,
  doc: PageLifecycleDocument,
): (flush: () => void) => () => void {
  return (flush) => {
    const onPageHide = (): void => flush();
    const onVisibility = (): void => {
      if (doc.visibilityState === 'hidden') flush();
    };
    win.addEventListener('pagehide', onPageHide);
    doc.addEventListener('visibilitychange', onVisibility);
    return () => {
      win.removeEventListener('pagehide', onPageHide);
      doc.removeEventListener('visibilitychange', onVisibility);
    };
  };
}
